const moment = require("moment-timezone");
const _ = require("lodash");

// timezones list
const tzList = moment.tz.names();

// regular expressions for date format definition
const months =
  "(?:Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|June?|July?|Aug(?:ust)?|Sep(?:tember)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)";
const date_sep = "\(\\s|\\/|-|\\.\)";
const ordinalDay = "((([1-2][0-9])|(3[0-1])|([1-9]))(th|rd|st|nd))";
const stringDay =
  "\(thirtieth|twentieth|\(thirty\(\(\\s|-\)?\(first|one\)\)?\)|\(\(twenty\(\\s|-\)\)?\(first|one|two|second|three|third|four\(th\)?\\b|fi\(ve|fth\)\\b|six\(th\)?\\b|seven\(th\)?\\b|eight\(h\)?\\b|nin\(e|th\)\\b\)\)|\(ten\(th\)?\\b|eleven\(th\)?|twel\(ve|fth\)|eighteen\(th\)?|\(thir|four|fif|six|seven|nine\)teen\(th\)?|twenty\)\)";
const DATE_ISO =
  "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(Z|((\\.\\d{3}Z)|((\\+|-)\\d{2}:?\\d{2})))";
const DAY_OF_WEEK = new RegExp(
  /(?:sun(?:day)?|mon(?:day)?|tue(?:sday)?|wed(?:nesday)?|thu(?:rsday)?|fri(?:day)?|sat(?:urday)?)(,?\s)?/,
  "i"
);

const TIME_STR = new RegExp(
  /\d+\s?(h(ours)?|m(inutes)?|s(econds)?|ms|milliseconds)/,
  "ig"
);

const TZ_OFFSET = new RegExp(
  /(\+(((0?\d|[1][0-4]):?00)|((0?([3-6]|[9])|[10]):?30)|((0?[5,8]):?45)))|((-|−)((((0?\d)|([1][0-2])):?00)|(0?[2,3,9]:?30)))/
);
const UTC_OFFSET = new RegExp(/UTC((\+|-)((1[0-2])|(0?\d)))|(\+1[3,4])/);
const HH_OFFSET_RANGE = "((\\+|-)((1[0-2])|(0?\\d)))|(\\+1[3,4])";
const TIMEZONES = new RegExp(
  "/" +
  tzList
  .sort((a, b) => b.length - a.length)
  .reduce((acc, tz, i) => {
    tz = tz.replace(/\//g, "\\$&").replace(/\+/g, "\\$&");
    if (i) acc = acc + "|" + tz;
    else acc = tz;
    return acc;
  }, "") +
  "/"
);
const DDMMYYYY = "((\\d\\d?-\\d\\d?-(\\d\\d\\d\\d))|(\\d\\d?\\.\\d\\d?\\.(\\d\\d\\d\\d))|(\\d\\d?\\/\\d\\d?\\/(\\d\\d\\d\\d)))"; 
const YYYYMMDD = "(((\\d\\d\\d\\d)-\\d\\d?-\\d\\d?)|((\\d\\d\\d\\d)\\.\\d\\d?\\.\\d\\d?)|((\\d\\d\\d\\d)\\/\\d\\d?\\/\\d\\d?))"; 
const YY_MM_DD = new RegExp(/(^((\d\d?-\d\d?-\d\d?)|(\d\d?\/\d\d?\/\d\d?)|(\d\d?\.\d\d?\.\d\d?)|(\d\d?\s\d\d?\s\d\d?))$)/);
const MMYYYY = /^((\d\d?(-|\/|\.|\s)\d{4})|(\d{4}(-|\/|\.|\s)\d\d?))$/;
const test_short_date = {
  YY_MM_DD: "(((\\d\\d?-\\d\\d?-\\d\\d?)|(\\d\\d?\\/\\d\\d?\\/\\d\\d?)|(\\d\\d?\\.\\d\\d?\\.\\d\\d?)))", // 12/12/12, 12.12.12, 12-12-12
  month_DD_YY: "(" + months + "\\/\\d\\d?\\/\\d\\d\\b)|(" + months + "\\.\\d\\d?\\.\\d\\d\\b)|(" + months + "-\\d\\d?-\\d\\d\\b)", // sep/12/12, sep.12.12, sep-12-12
  YY_DD_month: "(\\b\\d\\d\\/\\d\\d?\\/" + months + ")|(\\b\\d\\d\\.\\d\\d?\\." + months + ")|(\\b\\d\\d-\\d\\d?-" + months + ")", // 12/12/sep, 12.12.sep, 12-12-sep
  YY_month_DD: "(\\b\\d\\d?\\/" + months + "\\/\\d\\d?\\b)|(\\b\\d\\d?\\." + months + "\\.\\d\\d?\\b)|(\\b\\d\\d?-" + months + "-\\d\\d?\\b)" // 12/sep/12, 12.sep.12, 12-sep-12
}


const DURATION_STR = new RegExp(
  /\d+\s?(ms|millisecond(s)?|y(ear(s)?)?|M|month(s)?|w(eek(s)?)?|d(ay(s)?)?|h(our(s)?)?|min\b|m(inute(s)?)?|sec\b|s(econd(s)?)?)/,
  "g"
);

const DURATION_ISO =
  "(-?)P(?=\\d|T\\d)(?:(\\d+)Y)?(?:(\\d+)M)?(?:(\\d+)([DW]))?(?:T(?:(\\d+)H)?(?:(\\d+)M)?(?:(\\d+(?:\\.\\d+)?)S)?)?";

const dg = {
  zero: 0,
  one: "first",
  two: "second",
  three: "third",
  four: "fourth",
  five: "fifth",
  six: "sixth",
  seven: "seventh",
  eight: "eighth",
  nine: "ninth",
  ten: "tenth",
  eleven: "eleventh",
  twelve: "twelfth",
  thirteen: "thirteenth",
  fourteen: "fourteenth",
  fifteen: "fifteenth",
  sixteen: "sixteenth",
  seventeen: "seventeenth",
  eighteen: "eighteenth",
  nineteen: "nineteenth",
  twenty: "twentieth",
};
let AMPM_TIME = {};
let TIMES = {};

const shortDateTimeRegex = () => {
  // time
  const hh_a = "(\\b(([0]?[1-9])|1[0-2])\\s((am|pm)\\b))"; // 7 pm
  const hha = "(\\b(([0]?[1-9])|1[0-2])((am|pm)\\b))"; // 7pm
  const hhmmssA = "(\\b(([0]\\d)|([1][0-2]))([0-5]\\d)(([0-5]\\d))((am|pm)\\b))"; // 123000am
  const hhmmss_A = "(\\b(([0]\\d)|([1][0-2]))([0-5]\\d)(([0-5]\\d))\\s((am|pm)\\b))"; // 123000 am
  const hh_mm_a =
    "(\\b(([0]?[1-9])|1[0-2]):[0-5][0-9]\\s((am|pm)\\b))"; //  12:30 am
  const hh_mma =
    "(\\b(([0]?[1-9])|1[0-2]):[0-5][0-9]((am|pm)\\b))"; // 12:30am
  const hh_mm_ss_a =
    "(\\b(([0]?[1-9])|1[0-2]):[0-5][0-9]:[0-5][0-9]\\s((am|pm)\\b))"; //  12:30:00 am
  const hh_mm_ssa =
    "(\\b(([0]?[1-9])|1[0-2]):[0-5][0-9]:[0-5][0-9]((am|pm)\\b))"; //  12:30:00am

  const ampm_TIME = {
    [hh_a]: "hh a",
    [hha]: "hha",
    [hhmmssA]: "hhmmssa",
    [hhmmss_A]: "hhmmss a",
    [hh_mm_a]: "hh:mm a",
    [hh_mma]: "hh:mma",
    [hh_mm_ss_a]: "hh:mm:ss a",
    [hh_mm_ssa]: "hh:mm:ssa"
  };

  const hhmmss = "(\\b(((0|1)[0-9])|(2[0-4]))[0-5][0-9][0-5][0-9]\\b)"; // 123000
  const hh_mmZ =
    "((\\b(([1-9])|([0-1][0-9])|([2][0-4])):[0-5][0-9]((\\+|-)\\d{2}:?\\d{2}))\\b)"; //  12:30+0200, 12:45-03:00
  const h_mm_ss =
    "((\\b\\d:[0-5][0-9]:[0-5][0-9])\\b)"; // 2:30:00
  const hh_mm_ss =
    "((\\b(([1-9])|([0-1][0-9])|([2][0-4])):[0-5][0-9]:[0-5][0-9])\\b)"; // 12:30:00
  const hh_mm_ss_SSSz =
    "((\\b(([1-9])|([0-1][0-9])|([2][0-4])):[0-5][0-9]:[0-5][0-9]((\\.\\d{3}Z)))\\b)"; // 12:30:00.123Z
  const hh_mm_ssz =
    "((\\b(([1-9])|([0-1][0-9])|([2][0-4])):[0-5][0-9]:[0-5][0-9]Z)\\b)"; // 12:30:00Z
  const hh_mm = "(\\b(([1-9])|([0-1][0-9])|([2][0-4])):[0-5][0-9]\\b)"; // 12:30
  const hh_mm_ssZ =
    "((\\b(([1-9])|([0-1][0-9])|([2][0-4])):[0-5][0-9]:[0-5][0-9])((\\+|-)\\d{2}:?\\d{2})\\b)"; // 12:30:00+01:00
  const hh_mm_sszZ =
    "((\\b(([1-9])|([0-1][0-9])|([2][0-4])):[0-5][0-9]:[0-5][0-9])Z((\\+|-)\\d{2}:?\\d{2})\\b)"; // 12:30:00Z+01:00

  const simple_TIMES = {
    [hhmmss]: "HHmmss",
    [hh_mmZ]: "HH:mmZ",
    [h_mm_ss]: "H:mm:ss",
    [hh_mm_ss]: "HH:mm:ss",
    [hh_mm_ss_SSSz]: "HH:mm:ss.SSS[Z]",
    [hh_mm_ssz]: "HH:mm:ss[Z]",
    [hh_mm]: "HH:mm",
    [hh_mm_ssZ]: "HH:mm:ssZ",
    [hh_mm_sszZ]: "HH:mm:ss[Z]Z",
  }

  const month_date = {
    [test_short_date.month_DD_YY]: 'MMMM-DD-YY',
    [test_short_date.YY_DD_month]: 'YY-DD-MMMM',
    [test_short_date.YY_month_DD]: {
      format: 'YY-MMMM-DD',
      additional: ['DD-MMMM-YY']
    }
  };
  const simple_date = {
    [test_short_date.YY_MM_DD]: {
      format: 'MM-DD-YY',
      additional: ['DD-MM-YY', 'YY-MM-DD', 'YY-DD-MM']
    }
  };

  const STR_MONTH_DATE_TIME = getShortDatesTimesRegex(simple_TIMES, month_date);
  const STR_MONTH_DATE_AMPM_TIME = getShortDatesTimesRegex(ampm_TIME, month_date);
  const DATE_TIME = getShortDatesTimesRegex(simple_TIMES, simple_date);
  const DATE_AMPM_TIME = getShortDatesTimesRegex(ampm_TIME, simple_date);

  return {
    STR_MONTH_DATE_TIME,
    STR_MONTH_DATE_AMPM_TIME,
    DATE_TIME,
    DATE_AMPM_TIME
  }
}

const getShortDatesTimesRegex = (times, dates) => {
  const formats = Object.keys(times).reduce((obj, time) => {
    let dateFormat, timeFormat, additional;

    Object.keys(dates).forEach(date => {
      if (typeof dates[date] === "object") {
        dateFormat = dates[date].format;
        additional = dates[date].additional;
      } else {
        dateFormat = dates[date];
      }
      if (typeof times[time] === "object") timeFormat = times[time].format;
      else timeFormat = times[time];

      obj["(" + date + ")\\s" + time] = {
        format: dateFormat + " " + timeFormat,
        additionalFormats: (() => {
          if (additional) return additional.map(f => f + " " + timeFormat);
        })(),
        date: date,
      };
      obj[time + "\\s(" + date + ")"] = {
        format: timeFormat + " " + dateFormat,
        additionalFormats: (() => {
          if (additional) return additional.map(f => timeFormat + " " + f);
        })(),
        date: date,
      };
    });
    return obj;
  }, {});
  return formats;
}

const getDatesTimesRegex = () => {
  // time part
  const hh_a = "(\\b(([0]?[1-9])|1[0-2])\\s((am|pm)\\b))"; // 7 pm
  const hha = "(\\b(([0]?[1-9])|1[0-2])((am|pm)\\b))";
  const hhmmssA = "(\\b(([0]\\d)|([1][0-2]))([0-5]\\d)(([0-5]\\d))((am|pm)\\b))";
  const hhmmss_A = "(\\b(([0]\\d)|([1][0-2]))([0-5]\\d)(([0-5]\\d))\\s((am|pm)\\b))";
  const hh_mm_a =
    "((\\b(([0]?[1-9])|1[0-2])\\s[0-5][0-9]\\s((am|pm)\\b))|((([0]?[1-9])|1[0-2]):[0-5][0-9]\\s((am|pm)\\b))|(\\b(([0]?[1-9])|1[0-2])\\.[0-5][0-9]\\s((am|pm)\\b))|(\\b(([0]?[1-9])|1[0-2])-[0-5][0-9]\\s((am|pm)\\b))\\b)"; // 12 30 am
  const hh_mma =
    "((\\b(([0]?[1-9])|1[0-2])\\s[0-5][0-9]((am|pm)\\b))|(\\b(([0]?[1-9])|1[0-2]):[0-5][0-9]((am|pm)\\b))|(\\b(([0]?[1-9])|1[0-2])\\.[0-5][0-9]((am|pm)\\b))|(\\b(([0]?[1-9])|1[0-2])-[0-5][0-9]((am|pm)\\b))\\b)"; // 12 30am
  const hh_mm_ss_a =
    "((\\b(([0]?[1-9])|1[0-2])\\s[0-5][0-9]\\s[0-5][0-9]\\s((am|pm)\\b))|(\\b(([0]?[1-9])|1[0-2]):[0-5][0-9]:[0-5][0-9]\\s((am|pm)\\b))|(\\b(([0]?[1-9])|1[0-2])\\.[0-5][0-9]\\.[0-5][0-9]\\s((am|pm)\\b))|(\\b(([0]?[1-9])|1[0-2])-[0-5][0-9]-[0-5][0-9]\\s((am|pm)\\b))\\b)"; // 12 30 00 am
  const hh_mm_ssa =
    "((\\b(([0]?[1-9])|1[0-2])\\s[0-5][0-9]\\s[0-5][0-9]((am|pm)\\b))|(\\b(([0]?[1-9])|1[0-2]):[0-5][0-9]:[0-5][0-9]((am|pm)\\b))|(\\b(([0]?[1-9])|1[0-2])\\.[0-5][0-9]\\.[0-5][0-9]((am|pm)\\b))|(\\b(([0]?[1-9])|1[0-2])-[0-5][0-9]-[0-5][0-9]((am|pm)\\b))\\b)"; // 12 30 00am

  AMPM_TIME = {
    [hh_a]: "hh a",
    [hha]: "hha",
    [hhmmssA]: "hhmmssa",
    [hhmmss_A]: "hhmmss a",
    [hh_mm_a]: {
      format: "hh:mm a",
      sep: true,
    },
    [hh_mma]: {
      format: "hh:mma",
      sep: true,
    },
    [hh_mm_ss_a]: {
      format: "hh:mm:ss a",
      sep: true,
    },
    [hh_mm_ssa]: {
      format: "hh:mm:ssa",
      sep: true,
    },
  };

  const h_mm_ss =
    "((\\b\\d\\s[0-5][0-9]\\s[0-5][0-9])|(\\b\\d:[0-5][0-9]:[0-5][0-9])|(\\b\\d\\.[0-5][0-9]\\.[0-5][0-9])|(\\b\\d-[0-5][0-9]-[0-5][0-9])\\b)"; // 2:30:00
  const hh_mm_ss =
    "((\\b(([1-9])|([0-1][0-9])|([2][0-4]))\\s[0-5][0-9]\\s[0-5][0-9])|(\\b(([1-9])|([0-1][0-9])|([2][0-4])):[0-5][0-9]:[0-5][0-9])|(\\b(([1-9])|([0-1][0-9])|([2][0-4]))\\.[0-5][0-9]\\.[0-5][0-9])|(\\b(([1-9])|([0-1][0-9])|([2][0-4]))-[0-5][0-9]-[0-5][0-9])\\b)"; // 12:30:00
  const hh_mmZ =
    "((\\b(([1-9])|([0-1][0-9])|([2][0-4])):[0-5][0-9]((\\+|-)\\d{2}:?\\d{2}))|(\\b(([1-9])|([0-1][0-9])|([2][0-4]))\\.[0-5][0-9]((\\+|-)\\d{2}:?\\d{2}))|(\\b(([1-9])|([0-1][0-9])|([2][0-4]))-[0-5][0-9]((\\+|-)\\d{2}:?\\d{2}))\\b)"; // 12 30+0200, 12 45-03:00
  //12:30:00Z+01:00
  const hh_mm_ssz =
    "((\\b(([1-9])|([0-1][0-9])|([2][0-4]))\\s[0-5][0-9]\\s[0-5][0-9]Z)|(\\b(([1-9])|([0-1][0-9])|([2][0-4])):[0-5][0-9]:[0-5][0-9]Z)|(\\b(([1-9])|([0-1][0-9])|([2][0-4]))\\.[0-5][0-9]\\.[0-5][0-9]Z)|(\\b(([1-9])|([0-1][0-9])|([2][0-4]))-[0-5][0-9]-[0-5][0-9]Z)\\b)";
  const hh_mm_ss_SSSz =
    "((\\b(([1-9])|([0-1][0-9])|([2][0-4]))\\s[0-5][0-9]\\s[0-5][0-9]((\\.\\d{3}Z)))|(\\b(([1-9])|([0-1][0-9])|([2][0-4])):[0-5][0-9]:[0-5][0-9]((\\.\\d{3}Z)))|(\\b(([1-9])|([0-1][0-9])|([2][0-4]))\\.[0-5][0-9]\\.[0-5][0-9]((\\.\\d{3}Z)))|(\\b(([1-9])|([0-1][0-9])|([2][0-4]))-[0-5][0-9]-[0-5][0-9]((\\.\\d{3}Z)))\\b)";
  const hhmmss = "(\\b(((0|1)[0-9])|(2[0-4]))[0-5][0-9][0-5][0-9]\\b)"; // 123000

  TIMES = [" ", "-", ".", ":"].reduce(
    (acc, sep) => {
      const s =
        sep === " " ? "\\s" : sep === "-" ? "-" : sep === ":" ? ":" : "\\.";

      const hh_mm = "(\\b(([1-9])|([0-1][0-9])|([2][0-4]))" + s + "[0-5][0-9]\\b)"; // 12:30
      const hh_mmZ =
        "(\\b(([1-9])|([0-1][0-9])|([2][0-4]))" + s + "[0-5][0-9]((\\+|-)\\d{2}:?\\d{2})\\b)"; // 12 30+0200, 12 45-03:00

      //12:30:00Z+01:00
      const hh_mm_ssZ =
        "((\\b(([1-9])|([0-1][0-9])|([2][0-4]))" +
        s +
        "[0-5][0-9]" +
        s +
        "[0-5][0-9])((\\+|-)\\d{2}:?\\d{2})\\b)";
      const hh_mm_sszZ =
        "((\\b(([1-9])|([0-1][0-9])|([2][0-4]))" +
        s +
        "[0-5][0-9]" +
        s +
        "[0-5][0-9])Z((\\+|-)\\d{2}:?\\d{2})\\b)";

      acc[hh_mm] = "HH" + sep + "mm";
      acc[hh_mmZ] = "HH" + sep + "mmZ";
      acc[hh_mm_ssZ] = "HH" + sep + "mm" + sep + "ssZ";
      acc[hh_mm_sszZ] = "HH" + sep + "mm" + sep + "ss[Z]Z";

      return acc;
    }, {
      [hhmmss]: "HHmmss",
      [hh_mmZ]: {
        format: "HH:mmZ",
        sep: true,
      },
      [h_mm_ss]: {
        format: "H:mm:ss",
        sep: true,
      },
      [hh_mm_ss]: {
        format: "HH:mm:ss",
        sep: true,
      },
      [hh_mm_ss_SSSz]: {
        format: "HH:mm:ss.SSS[Z]",
        sep: true,
      },
      [hh_mm_ssz]: {
        format: "HH:mm:ss[Z]",
        sep: true,
      },
    }
  );

  // date part
  const yearReg = "(\\b\\d\\d\\d\\d\\b)";
  const numDayOfMonth = "(([1-2][0-9])|(3[0-1])|([1-9])|(0\\d))";

  let ordinalDay_date = {},
    stringDay_date = {},
    stringDay_year_date = {},
    ordinalDay_year_date = {},
    simple_date_year = {},
    simple_day_month = {};

  simple_day_month[numDayOfMonth + date_sep + months] = "DD-MMMM";
  simple_day_month[months + date_sep + numDayOfMonth] = "MMMM-DD";

  simple_date_year[numDayOfMonth + date_sep + months + date_sep + yearReg] =
    "DD-MMMM-YYYY";
  simple_date_year[yearReg + date_sep + numDayOfMonth + date_sep + months] =
    "YYYY-DD-MMMM";
  simple_date_year[months + date_sep + numDayOfMonth + date_sep + yearReg] =
    "MMMM-DD-YYYY";
  simple_date_year[yearReg + date_sep + months + date_sep + numDayOfMonth] =
    "YYYY-MMMM-DD";

  ordinalDay_date[ordinalDay + date_sep + months] = "Do-MMMM";
  ordinalDay_date[months + date_sep + ordinalDay] = "MMMM-Do";

  ordinalDay_year_date[ordinalDay + date_sep + months + date_sep + yearReg] =
    "Do-MMMM-YYYY";
  ordinalDay_year_date[yearReg + date_sep + ordinalDay + date_sep + months] =
    "YYYY-Do-MMMM";
  ordinalDay_year_date[months + date_sep + ordinalDay + date_sep + yearReg] =
    "MMMM-Do-YYYY";
  ordinalDay_year_date[yearReg + date_sep + months + date_sep + ordinalDay] =
    "YYYY-MMMM-Do";

  stringDay_date[stringDay + date_sep + months] = {
    format: "DD-MMMM",
    stringDay: true,
  };
  stringDay_date[months + date_sep + stringDay] = {
    format: "MMMM-DD",
    stringDay: true,
  };

  stringDay_year_date[stringDay + date_sep + months + date_sep + yearReg] = {
    format: "DD-MMMM-YYYY",
    stringDay: true,
  };
  stringDay_year_date[yearReg + date_sep + stringDay + date_sep + months] = {
    format: "YYYY-DD-MMMM",
    stringDay: true,
  };
  stringDay_year_date[yearReg + date_sep + months + date_sep + stringDay] = {
    format: "YYYY-MMMM-DD",
    stringDay: true,
  };
  stringDay_year_date[months + date_sep + stringDay + date_sep + yearReg] = {
    format: "MMMM-DD-YYYY",
    stringDay: true,
  };

  return {
    simple_day_month,
    simple_date_year,
    stringDay_date,
    ordinalDay_date,
    ordinalDay_year_date,
    stringDay_year_date,
    TIMES,
    AMPM_TIME,
  };
};

const generator = (dates, times) => {
  const formats = Object.keys(dates).reduce((acc, date, i) => {
    acc = Object.assign(
      acc,
      Object.keys(times).reduce((obj, time) => {
        let dateFormat, timeFormat;

        if (typeof dates[date] === "object") dateFormat = dates[date].format;
        else dateFormat = dates[date];

        if (typeof times[time] === "object") timeFormat = times[time].format;
        else timeFormat = times[time];

        obj[date + "\\s" + time] = {
          stringDay: typeof dates[date] === "object",
          timeSep: typeof times[time] === "object",
          format: dateFormat + " " + timeFormat,
          date: date,
          time: time,
        };
        obj[time + "\\s" + date] = {
          stringDay: typeof dates[date] === "object",
          timeSep: typeof times[time] === "object",
          format: timeFormat + " " + dateFormat,
          date: date,
          time: time,
        };
        return obj;
      }, {})
    );
    return acc;
  }, {});

  return formats;
};

const generateRegex = () => {
  const {
    simple_day_month,
    simple_date_year,
    TIMES,
    AMPM_TIME,
    stringDay_date,
    ordinalDay_date,
    stringDay_year_date,
    ordinalDay_year_date,
  } = getDatesTimesRegex();

  const simple_date_time = generator(simple_day_month, TIMES);
  const simple_date_ampm = generator(simple_day_month, AMPM_TIME);

  const simple_date_year_time = generator(simple_date_year, TIMES);
  const simple_date_year_ampm = generator(simple_date_year, AMPM_TIME);

  const stringDay_time = generator(stringDay_date, TIMES);
  const stringDay_date_ampm = generator(stringDay_date, AMPM_TIME);
  const stringDay_year_ampm = generator(stringDay_year_date, AMPM_TIME);
  const stringDay_year_time = generator(stringDay_year_date, TIMES);

  const ordinalDay_time = generator(ordinalDay_date, TIMES);
  const ordinalDay_date_ampm = generator(ordinalDay_date, AMPM_TIME);
  const ordinalDay_year_ampm = generator(ordinalDay_year_date, AMPM_TIME);
  const ordinalDay_year_time = generator(ordinalDay_year_date, TIMES);

  const year_month_day_time = generator({
    [YYYYMMDD]: 'YYYY-MM-DD'
  }, TIMES);
  const year_month_day_ampm = generator({
    [YYYYMMDD]: 'YYYY-MM-DD'
  }, AMPM_TIME);
  const day_month_year_time = generator({
    [DDMMYYYY]: 'MM-DD-YYYY'
  }, TIMES);
  const day_month_year_ampm = generator({
    [DDMMYYYY]: 'MM-DD-YYYY'
  }, AMPM_TIME);

  return {
    simple_date_time, // simple day + month + time
    simple_date_ampm, // simple day + month + am/pm time
    simple_date_year_time, // simple day + month + year + time
    simple_date_year_ampm, // simple day + month + year + am/pm time
    stringDay_time, // string day + month + time
    stringDay_date_ampm, // string day + month + am/pm time
    stringDay_year_date, // string day + month + year
    stringDay_year_ampm, // string day + month + year + am/pm time
    stringDay_year_time, // string day + month + year + time
    ordinalDay_time, // ordinal day + month + time
    ordinalDay_date_ampm, // ordinal day + month + am/pm time
    ordinalDay_year_date, // ordinal day + month + year
    ordinalDay_year_ampm, // ordinal day + month + year + am/pm time
    ordinalDay_year_time, // ordinal day + month + year + time
    simple_date_year, // simple day + month + year

    year_month_day_time, // 12-12-2021
    year_month_day_ampm,
    day_month_year_time,
    day_month_year_ampm
  };
};

const MATCH_DATE = generateRegex();

const MATCH_SHORT_DATE_TIME = shortDateTimeRegex()
// end regexp

class timeInterpreter {
  // methods
  getTimezonesList() {
    return tzList;
  }
  parse(xValue, xTimezone, yTimezone, xYear, xDate) {

    const weekDays = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    let result = {
        time: null,
        duration: null,
        iso: null,
        isoWithFractSec: null,
        date: null,
      },
      type = "datetime",
      tz,
      momentDate,
      original;

    if (!xYear || !/(\b\d\d\d\d\b)/.test(xYear)) xYear = moment().get("year"); 
    if (!xTimezone) xTimezone = "GMT+0";

    switch (typeof xValue) {
      case "object": // value object
        // ['milliseconds', 'seconds', 'minutes', 'hours', 'days', 'weeks', 'months', 'years']

        type = "datetime";
        result.duration = moment.duration(xValue).asMilliseconds();

        if (
          !xValue.years &&
          !xValue.year &&
          !xValue.y &&
          !xValue.months &&
          !xValue.month &&
          !xValue["M"] &&
          !xValue.date &&
          !xValue.day &&
          !xValue.days &&
          !xValue.d
        ) {
          const syntax = () => {
            const temp1 = ["y", "M", "d", "h", "m", "s", "ms"];
            const temp2 = [
              "year",
              "month",
              "day",
              "hour",
              "minute",
              "second",
              "millisecond",
            ];
            const temp3 = [
              "years",
              "months",
              "days",
              "date",
              "hours",
              "minutes",
              "seconds",
              "milliseconds",
            ];
            if (Object.keys(xValue).some((item) => temp1.indexOf(item) !== -1))
              return temp1;
            if (Object.keys(xValue).some((item) => temp2.indexOf(item) !== -1))
              return temp2;
            if (Object.keys(xValue).some((item) => temp3.indexOf(item) !== -1))
              return temp3;
          };

          if (xDate) {
            let datePart = moment.utc(xDate, "YYYY-MM-DD");
            if (datePart.format() === "Invalid date") return null;
            xValue[syntax()[0]] = datePart.get("year");
            xValue[syntax()[1]] = datePart.get("month");
            xValue[syntax()[2]] = datePart.get("date");
            
            if (tzList.indexOf(xTimezone) !== -1) original = moment.tz(xValue, xTimezone);
            else original = moment.parseZone(setTimezone(moment.utc(xValue).format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"), '', xTimezone));
          } else {
            type = "time";
            if (tzList.indexOf(xTimezone) !== -1) {
              original = moment.tz(xValue, xTimezone);
            } else {
              original = setTimezone(moment.utc(xValue), '', xTimezone);
              original = moment.parseZone(original);
            }
          }
        } else if (
          !xValue.years &&
          !xValue.year &&
          !xValue.y &&
          (xValue.months || xValue.month || xValue["M"]) &&
          (xValue.date || xValue.day || xValue.days || xValue.d)
        ) {
          if (
            !xValue.hours &&
            !xValue.hour &&
            !xValue.h &&
            !xValue.minutes &&
            !xValue.minute &&
            !xValue["m"] &&
            !xValue.seconds &&
            !xValue.second &&
            !xValue.s
          ) {
            type = 'date';
          }
         
            if (tzList.indexOf(xTimezone) !== -1) {
              original = moment.tz(xValue, xTimezone).set("year", xYear);
            } else {
              original = setTimezone(moment(xValue).set("year", xYear).format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"), '', xTimezone);
              original = moment.parseZone(original);
            }
         
          result.duration = moment.duration(result.iso).asMilliseconds();
        } else {
          if (
          !xValue.hours &&
          !xValue.hour &&
          !xValue.h &&
          !xValue.minutes &&
          !xValue.minute &&
          !xValue["m"] &&
          !xValue.seconds &&
          !xValue.second &&
          !xValue.s
        ) {
          type = 'date';
        }
        
          if (tzList.indexOf(xTimezone) !== -1) {
            original = moment.tz(xValue, xTimezone);
          } else {
            original = setTimezone(moment(xValue).format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"), '', xTimezone);
            original = moment.parseZone(original);
          }
          if (!/(\b\d\d\d\d\b)/.test(original.year())) type = "time";
        }
        tz = xTimezone;
        if (original && original.format() !== "Invalid date") {
          if (yTimezone && type !== "date" && type !== "time") {
            tz = yTimezone;
            if (tzList.indexOf(yTimezone) !== -1) momentDate = moment(original.format()).tz(yTimezone);
            else momentDate = moment(original.format()).utcOffset(yTimezone);
          } else {
            momentDate = original.clone();
          }
          switch (type) {
            case "time":
              result.iso = momentDate.clone().format("HH:mm:ssZ");
              result.isoWithFractSec = momentDate.clone().format("HH:mm:ss.SSSZ");
              break;
            default:
              result.iso = momentDate.clone().format("YYYY-MM-DD[T]HH:mm:ssZ");
              result.isoWithFractSec = momentDate.clone().format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");
            }

        
            result.timezone = {
              name: tzList.indexOf(tz) !== -1 ? tz : "",
              offsetNum: momentDate.utcOffset() / 60,
              offsetText: momentDate.clone().format("Z"),
            };
         
        }
        break;
      case "number": // ms duration, UNIX sec/milisec

        original = moment.unix(xValue).utc();
        if (original.format() !== "Invalid date") {
          if (
            original.toISOString().split("-")[0].length > 4 ||
            !/(\b[1-2][0-9]{3}\b)/.test(original.year())
          ) {
            original = moment.utc(xValue);
          }
        }
        
        tz = xTimezone;
        if (tzList.indexOf(xTimezone) !== -1) {
          momentDate = moment.tz(
            original.format("YYYY-MM-DD[T]HH:mm:ss.SSS"),
            xTimezone
          );
        } else {
          original = setTimezone(original.format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"), '', xTimezone);
          momentDate = moment.parseZone(original);
        }

        if (yTimezone) {
          tz = yTimezone;
          if (tzList.indexOf(yTimezone) !== -1) momentDate = momentDate.tz(yTimezone);
          else momentDate = momentDate.utcOffset(yTimezone);
        }
        result.timezone = {
          name: tzList.indexOf(tz) !== -1 ? tz : "",
          offsetNum: momentDate.utcOffset() / 60,
          offsetText: momentDate.clone().format("Z"),
        };
        result.duration = momentDate.clone().valueOf();
        result.iso = momentDate.clone().format("YYYY-MM-DD[T]HH:mm:ssZ");
        result.isoWithFractSec = momentDate.clone().format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");
        
        type = "datetime";

        break;
      case "string":
        let parsed;

        type = "datetime";
        const isoDate = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(((\.\d{3}Z)|(Z?(\+|-)\d{2}:?\d{2})|Z))$/;
        if (xValue.match(isoDate)) {
          // default format
          tz = xValue.match(/(((\.\d{3}Z)|(Z?(\+|-)\d{2}:?\d{2})|Z))$/)[0];
          if (/^(Z(\+|-)\d{2}:?\d{2})$/.test(tz)) {
            tz = tz.replace('Z', '');
            xValue = xValue.replace('Z', '');
          }
          original = moment.parseZone(xValue).format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");
          
        } else if (xValue.match(new RegExp(DATE_ISO + "?\\/" + DURATION_ISO))) {
          const date = xValue.match(new RegExp(DATE_ISO + "?"))[0];
          const dur = xValue.match(new RegExp(DURATION_ISO))[0];
          original = moment
            .utc(date)
            .add(moment.duration(dur).asMilliseconds())
            .format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");
        } else if (
          /^(\d\d\d\d)((0\d)|(1[0-2]))((0\d)|(2\d)|(3[0-1]))(\s|T)((0\d)|(1\d)|(2[0-3]))([0-5]\d[0-5]\d)$/.test(
            xValue
          )
        ) {
          original = moment.utc(
            xValue.replace("T", " "),
            "YYYYMMDD HHmmss"
          ).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
        } else if (
          /\d{4}((1[0-2])|(0\d))(([0-2]\d)|(3[0,1]))(\s|T)?([0-2]\d[0-5]\d[0-5]\d)\s?((\+(((0?\d|[1][0-4]):?00)|((0?([3-6]|[9])|[10]):?30)|((0?[5,8]):?45)))|((-|−)((((0?\d)|([1][0-2])):?00)|(0?[2,3,9]:?30))))/.test(
            xValue
          )
        ) {
          let match = xValue.match(/(\+|-)\d{2}(\d{2})?/);
          tz = getTimezoneOffset(match[0]).offset;
          original =
            moment
            .utc(_.trim(xValue.substring(0, match.index), " "))
            .toISOString()
            .slice(0, -5) + ".000" + tz;
            
        } else if (new RegExp("^(\\d\\d" + months + "\\d\\d\\d\\d)$",'i').test(xValue)){
          type = "date";
          original = moment.utc(xValue, 'DDMMMMYYYY').format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");
          
        } else {
          if (
            new RegExp(
              "^(([4-9]\\d)|(3[2-9]))" + date_sep + months + "$",
              "i"
            ).test(xValue) ||
            new RegExp(
              "^" + months + date_sep + "(([4-9]\\d)|(3[2-9]))$",
              "i"
            ).test(xValue)
          ) {
            result = null;
          } else {
            parsed = matchDateFormat(xValue, xYear); // string MONTH or/and string DAY (optional + year)
            
            if (!parsed) {
              let trimmed = getZoneAndWeekday(xValue, tz);
              xValue = trimmed.date;
              tz = trimmed.tz;
              
              parsed = parseAmTime(xValue, tz); // am/pm time
              
              if (!parsed) {
                parsed = processDateString(xValue, xYear, tz, trimmed.weekDay); // date + time match
                
                if (parsed) {
                  if (parsed.type) type = parsed.type;
                  else type = "datetime";
                } else {
                  parsed = parseTime(xValue, tz); // TIME STRING
               
                  if (!parsed) parsed = getTime(xValue, tz); // unusual type
                  if (parsed) {
                    type = "time";
                    original = parsed.time;
                    tz = parsed.tz;
                  }
                }
              } else {
                type = "time";
                original = parsed.time;
                tz = parsed.tz;
              }
              // Time
              if (type === "time" && original && original !== "Invalid date") {
                if ((!tz || !tz.offset) && original.match(/(\+|-)\d{2}:\d{2}$/)) {
                  if (!tz) tz = {
                    offset: original.match(/(\+|-)\d{2}:\d{2}$/)[0]
                  };
                  else tz.offset = original.match(/(\+|-)\d{2}:\d{2}$/)[0];
                }

                if (!tz) {
                  if (tzList.indexOf(xTimezone) !== -1) tz = {
                    location: xTimezone
                  };
                  else tz = {
                    offset: xTimezone
                  };
                }
                
                if (xDate) {
                  type = "datetime";
                  original = xDate + "T" + original;

                  if (tz.offset !== "Z") {
                    if (tz.location) original = setTimezone(moment.parseZone(original).format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"), '', tz.location);
                    else original = setTimezone(moment.parseZone(original).format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"), '', tz.offset);
                  }

                } else {
                  if (tz.offset === "Z") original = '2020-10-10T' + original;
                  else if (tz.location) original = setTimezone(moment.parseZone(original, "HH:mm:ss.SSSZ").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"), '', tz.location);
                  else original = setTimezone(moment.parseZone(original, "HH:mm:ss.SSSZ").format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"), '', tz.offset);                
                  
                  momentDate = moment.parseZone(original);
                  if (tz.offset === "Z") result.iso = momentDate.format("HH:mm:ss") + "Z";
                  else result.iso = momentDate.format("HH:mm:ssZ");
                  result.isoWithFractSec = original.split("T")[1];

                  result.timezone = {
                    name: tz.location ? tz.location : "",
                    offsetNum: momentDate.utcOffset() / 60,
                    offsetText: momentDate.clone().format("Z"),
                  };
                  result.duration = moment
                    .duration(momentDate.format("HH:mm:ss"))
                    .asMilliseconds();
                }
              }
            }
          }
          
          // Date/time
          if (
            (type === "datetime" || type === "date") &&
            !original &&
            (parsed && parsed !== "Invalid date") &&
            (parsed.date && parsed.date !== "Invalid date")
          ) {
            original = parsed.date;
            tz = parsed.tz;
            if (parsed.type) type = parsed.type;
          }
        }
        
        if (!_.isNull(result) && original && type !== "time") {
          if (((!tz && xTimezone) || yTimezone)) { 
            original = setTimezone(original, tz, xTimezone, yTimezone);
            if (_.isNull(original)) return null;
            tz = yTimezone ? yTimezone : xTimezone;
          }
          
          if (tz && tz !== 'Z') {
            if (tzList.indexOf(tz) === -1) {
              momentDate = moment.parseZone(original, "YYYY-MM-DD[T]HH:mm:ss.SSSZ"); 
              result.iso = momentDate.format("YYYY-MM-DD[T]HH:mm:ssZ");
              result.timezone = {
                name: "",
              };
            } else {
              momentDate = moment.parseZone(original, "YYYY-MM-DD[T]HH:mm:ss.SSSZ"); 
              result.iso = momentDate.format("YYYY-MM-DD[T]HH:mm:ssZ");
              result.timezone = {
                name: tz,
              };
            }
          } else {
            result.timezone = {
              name: "",
            };
            momentDate = moment(original, "YYYY-MM-DD[T]HH:mm:ss.SSSZ"); 
            result.iso = momentDate.format();
          }
          result.timezone["offsetNum"] = momentDate.utcOffset() / 60;
          result.timezone["offsetText"] = momentDate.clone().format("Z");
          result.isoWithFractSec = momentDate.format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");
          result.duration = moment(result.iso).valueOf();
        }
        break;
    }

    if (result && momentDate) {
      if (type !== "time") {
        result["date"] = {
          dayOfWeek: weekDays[momentDate.day()],
          isWeekend: false,
          day: momentDate.get("date"),
          month: momentDate.get("month") + 1,
          monthName: momentDate.clone().format("MMMM"),
          year: momentDate.get("year"),
        };
        if (["Sunday", "Saturday"].includes(result.date.dayOfWeek))
          result.date.isWeekend = true;
        else result.date.isWeekend = false;
      }

        result["time"] = {
          hourMinute12: momentDate.clone().format("hh:mm"),
          hourMinute24: momentDate.clone().format("HH:mm"),
          hour12: Number(momentDate.clone().format("hh")),
          hour24: momentDate.get("hour"),
          amPm: momentDate.clone().format("a"),
          minute: momentDate.get("minute"),
        };
     
    }
   
    return result;
  }

  formatDatetime(xDate, ignoreTime, xTimezone, yTimezone, xYear) {
    let result, isoWithFractSec, tz, timezoneOffset, zoneName, offsetNum, type = '';
    if (!xYear || !/(\b\d\d\d\d\b)/.test(xYear)) xYear = moment().get("year");

    switch (typeof xDate) {
      case "object": // date object
        if (
          !xDate.hours &&
          !xDate.hour &&
          !xDate.h &&
          !xDate.minutes &&
          !xDate.minute &&
          !xDate["m"] &&
          !xDate.seconds &&
          !xDate.second &&
          !xDate.s
        ) {
          type = 'date';
        }
        if (
          !xDate.years &&
          !xDate.year &&
          !xDate.y &&
          (xDate.months || xDate.month || xDate["M"]) &&
          (xDate.date || xDate.day || xDate.days || xDate.d)
        ) result = moment.utc(xDate).set('year', xYear).toISOString();
        else result = moment.utc(xDate).toISOString();
        
        break;

      case "number": // ms duration, UNIX sec/milisec
        result = moment.unix(xDate);
        if (result.format() !== "Invalid date") {
          if (
            result.toISOString().split("-")[0].length > 4 ||
            !/(\b[1-2][0-9]{3}\b)/.test(result.year())
          ) {
            result = moment.utc(xDate).toISOString();
          } else {
            result = result.toISOString();
          }
        }
        break;

      case "string":
        if (
          xDate.length < 4 ||
          (xDate.length === 4 && !/\d\d\d\d/.test(xDate))
        ) {
          result = "Invalid date";
        } else {
          const isoDate = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(((\.\d{3}Z)|(Z?(\+|-)\d{2}:?\d{2})|Z))$/;
          if (xDate.match(isoDate)) {
            // default format
            tz = xDate.match(/(((\.\d{3}Z)|(Z?(\+|-)\d{2}:?\d{2})|Z))$/)[0];
            if (/^(Z(\+|-)\d{2}:?\d{2})$/.test(tz)) {
              tz = tz.replace('Z', '');
              xDate = xDate.replace('Z', '');
            }
           
            if (/Z$/.test(xDate)) result = moment.parseZone(xDate).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
            else result = moment.parseZone(xDate).format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");

          } else if (
            xDate.match(new RegExp(DATE_ISO + "?\\/" + DURATION_ISO))
          ) {
            const date = xDate.match(new RegExp(DATE_ISO + "?"))[0];
            const dur = xDate.match(new RegExp(DURATION_ISO))[0];
            result = moment
              .utc(date)
              .add(moment.duration(dur).asMilliseconds())
              .format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
          } else if (
            /^(\d\d\d\d)((0\d)|(1[0-2]))((0\d)|(2\d)|(3[0-1]))(\s|T)((0\d)|(1\d)|(2[0-3]))([0-5]\d[0-5]\d)$/.test(
              xDate
            )
          ) {
            result = moment.utc(
              xDate,
              "YYYYMMDD[T]HHmmss"
            ).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
          } else if (
            /\d{4}((1[0-2])|(0\d))(([0-2]\d)|(3[0,1]))(\s|T)?([0-2]\d[0-5]\d[0-5]\d)\s?((\+(((0?\d|[1][0-4]):?00)|((0?([3-6]|[9])|[10]):?30)|((0?[5,8]):?45)))|((-|−)((((0?\d)|([1][0-2])):?00)|(0?[2,3,9]:?30))))/.test(
              xDate
            )
          ) {
            let match = xDate.match(/(\+|-)\d{2}(\d{2})?/);
            tz = getTimezoneOffset(match[0]).offset;
            const date = _.trim(xDate.substring(0, match.index), " ");
            
            result = moment.utc(date);
            result = result.toISOString().slice(0, -5) + ".000" + tz;
          } else if (new RegExp("^(\\d\\d" + months + "\\d\\d\\d\\d)$",'i').test(xDate)){ // DDMMMMYYYY
            type = "date";
            result = moment.utc(xDate, 'DDMMMMYYYY').format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
          } else {
            if (
              new RegExp(
                "^(([4-9]\\d)|(3[2-9]))" + date_sep + months + "$",
                "i"
              ).test(xDate) ||
              new RegExp(
                "^" + months + date_sep + "(([4-9]\\d)|(3[2-9]))$",
                "i"
              ).test(xDate)
            ) {
              result === null;
            } else {
              xDate = trimString(xDate);
              result = matchDateFormat(xDate, xYear, ignoreTime); // DD MMMM, DD MMMM HH:mm:ss
             
              if (!result) result = processDateString(xDate, xYear);
              
              if (result) {
                tz = result.tz;
                if (result.type) type = result.type;
                result = result.date;

                if (tz && tz !== "Z") result = setTimezone(result, '', tz);
              }
            }
          }
        }
        break;
    }
    
    if (result) { 
      if (!ignoreTime) {
        if (((!tz && xTimezone) || yTimezone)) {
          result = setTimezone(result, tz, xTimezone, yTimezone);
          if (_.isNull(result)) return null;
          tz = yTimezone ? yTimezone : xTimezone;
        }
        if (tz && tzList.indexOf(tz) === -1) {
          timezoneOffset = tz ? tz : /Z$/.test(result) ? "Z" : "+00:00";
          offsetNum = moment(result, "YYYY-MM-DD[T]HH:mm:ss.SSSZ").utcOffset(timezoneOffset).utcOffset() / 60;
          zoneName = "";
        } else if (tz && tzList.indexOf(tz) !== -1) { 
          timezoneOffset = moment(result).tz(tz).format("Z");
          offsetNum = moment(result).tz(tz).utcOffset() / 60;
          zoneName = tz;
        } else if (!tz) {
          
          if (/Z$/.test(result)) {
            timezoneOffset = 'Z';
          } else {
            timezoneOffset = moment.parseZone(result).format("Z"); 
          }
          offsetNum = moment.parseZone(result).utcOffset() / 60;
          zoneName = "";
        }
      } else if (type === 'date') {
        result = result.split('T')[0];
      }
    }
    
    if (result) {
      if (!tz || tz.offset === "Z" || tz === "Z") {
        
        if (type === 'date' && ignoreTime) {
          if (!/^\d\d\d\d-\d\d-\d\d$/.test(result)) {
            result = moment.parseZone(result, "YYYY-MM-DD[T]HH:mm:ss.SSSZ").format("YYYY-MM-DD");
            isoWithFractSec = moment.parseZone(result, "YYYY-MM-DD[T]HH:mm:ss.SSSZ").format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
          } else {
            isoWithFractSec = result + "T00:00:00.000Z";
          }
        } else {
          isoWithFractSec = result;
          result = moment.parseZone(result, "YYYY-MM-DD[T]HH:mm:ss.SSSZ").format("YYYY-MM-DD[T]HH:mm:ss[Z]");
        }
      } else {
        if (/^\d\d\d\d-\d\d-\d\d$/.test(result)) isoWithFractSec = result + "T00:00:00.000Z";
        else isoWithFractSec = result;
        if (ignoreTime && /^\d\d\d\d-\d\d-\d\d$/.test(result)) result = moment.parseZone(result, "YYYY-MM-DD[T]HH:mm:ss.SSSZ").format("YYYY-MM-DD");
        else result = moment.parseZone(result, "YYYY-MM-DD[T]HH:mm:ss.SSSZ").format("YYYY-MM-DD[T]HH:mm:ssZ");
      }
    }

    return {
      date: result ? result : 'Invalid date',
      isoWithFractSec,
      timezoneOffset,
      zoneName,
      offsetNum,
    };
  }

  formatTime(xTime, xTimezone) {
    let result, time, timeWithFractSec, timezoneOffset, zoneName, offsetNum, tz;

    switch (typeof xTime) {
      case "string":
        xTime = trimString(xTime);

        if (TIMEZONES.test(xTime)) {
          let value;
          const matchZone = xTime.match(TIMEZONES);
          tz = {
            location: matchZone[0]
          };

          if (matchZone.index)
            value =
            xTime.slice(0, matchZone.index) +
            xTime.slice(tz.location.length + matchZone.index);
          else value = xTime.slice(tz.location.length);

          value = trimString(value);
          result = processTimeString(value, tz);
        } else {
          result = processTimeString(xTime, tz);
        }
        break;
        
      default:
        let hh, mm, ss;
        hh = moment.duration(xTime).get("hours");
        mm = moment.duration(xTime).get("minutes");
        ss = moment.duration(xTime).get("seconds");

        if (hh.toString().length === 1) hh = '0' + hh.toString();
        if (mm.toString().length === 1) mm = '0' + mm.toString();
        if (ss.toString().length === 1) ss = '0' + ss.toString();
        result = {
          time: hh + ":" + mm + ":" + ss + ".000"
        }
    }

    if (result && result.time && result.time !== "Invalid date") {
      time = result.time;
      tz = result.tz;
      
      if ((!tz || !tz.offset) && time.match(/(\+|-)\d{2}:\d{2}$/)) {
        if (!tz) tz = {
          offset: time.match(/(\+|-)\d{2}:\d{2}$/)[0]
        };
        else tz.offset = time.match(/(\+|-)\d{2}:\d{2}$/)[0];
      }
  
      if (!tz && xTimezone) {
        if (tzList.indexOf(xTimezone) !== -1) {
          tz = {
            location: xTimezone
          };
          time = setTimezone(moment.parseZone(time, "HH:mm:ssZ"), '', tz.location);
          zoneName = tz.location;
        } else {
          tz = {
            offset: xTimezone
          };
          time = setTimezone(moment.parseZone(time, "HH:mm:ssZ"), '', tz.offset);
          zoneName = "";
        };

        time = moment.parseZone(time);

        timezoneOffset = time.clone().format("Z");
        offsetNum = time.clone().utcOffset() / 60;
        timeWithFractSec = time.format("HH:mm:ss.SSSZ");
        time = time.format("HH:mm:ssZ");
      } else if (tz) {
        if (tz.location) {
          time = setTimezone(moment.parseZone(time, "HH:mm:ssZ").format("YYYY-MM-DD[T]HH:mm:ssZ"), '', tz.location);
          time = moment.parseZone(time);
          timeWithFractSec = time.format("HH:mm:ss.SSSZ");
          timezoneOffset = time.clone().format("Z");
          offsetNum = time.clone().utcOffset() / 60;
          time = time.format("HH:mm:ssZ");
          zoneName = tz.location;
        } else if (tz.offset) {
          timeWithFractSec = time;
          time = moment.parseZone(time, "HH:mm:ss.SSSZ");
          if (tz.offset === "Z") time = time.format("HH:mm:ss") + "Z";
          else time = time.format("HH:mm:ssZ");
    
          timezoneOffset = tz.offset;
          offsetNum = moment.parseZone(time, "HH:mm:ssZ").utcOffset() / 60;
          zoneName = "";
        }
      } else {
        timeWithFractSec = time + 'Z';
        time = moment.parseZone(time, "HH:mm:ss.SSS");
        time = time.format("HH:mm:ss[Z]");
        timezoneOffset = "Z";
        offsetNum = 0;
        zoneName = "";
      }
    }

    return {
      time,
      timezoneOffset,
      timeWithFractSec,
      zoneName,
      offsetNum,
    };
  }

  formatTimezone(inputValue, asObject) {
    const tz_Offset = /(^\+((((0?\d)|([1][0-4])):?00$)|(((0?([3-6]|[9]))|[10]):?30$)|(0?[5,8]:?45$)))|(^(-|−)((((0?\d)|([1][0-2])):?00$)|(0?[2,3,9]:?30$)))/;
    const OFFSET_IN_MIN = new RegExp(/(\+|-)\d{3}\s?$/);
    let result, zoneName, match, sep, hh;
    sep = /\+/.test(inputValue) ? "+" : "-";
    match =
      inputValue.match(UTC_OFFSET) ||
      inputValue.match(tz_Offset) ||
      inputValue.match(OFFSET_IN_MIN) ||
      inputValue.match(new RegExp(HH_OFFSET_RANGE));
    match = match ? match[0] : "";

    if (UTC_OFFSET.test(inputValue)) {
      match = match.match(new RegExp(HH_OFFSET_RANGE))[0];
      match = match.match(/((1[0-2])|(0?\d))|(\+1[3,4])/)[0];
      match = match.length === 1 ? "0" + match : match;
      result = sep + match + ":00";
    } else if (tzList.indexOf(inputValue) !== -1) {
      result = moment().tz(inputValue).format("Z");
      zoneName = inputValue;
    } else if (tz_Offset.test(inputValue)) {
      if (/:/.test(match)) {
        match = match.split(":");
        hh = match[0].match(/\d\d?/)[0];
        hh = hh.length === 1 ? "0" + hh : hh;
        result = sep + hh + ":" + match[1];
      } else {
        hh = match.slice(0, 3);
        let mm = match.slice(3).length === 1 ? '0' + match.slice(3) : match.slice(3);
        result = hh + ":" + mm;
      }
    } else if (OFFSET_IN_MIN.test(inputValue)) {
      match = match.slice(1);
      if (_.inRange(match, 0, 840)) {
        hh = _.toString(_.floor(match / 60));
        let mm = match % 60;
        hh = hh.length === 1 ? "0" + hh : hh;
        mm = mm ? ":30" : ":00";
        result = sep + hh + mm;
      }
    } else if (new RegExp("^(" + HH_OFFSET_RANGE + ")$").test(inputValue)) {
      let hh = inputValue.match(/\d\d?/)[0];
      hh = hh.length === 1 ? "0" + hh : hh;
      result = sep + hh + ":00";
    }
    if (result) {
      if (asObject)
        return {
          name: zoneName,
          offsetNum: moment().utcOffset(result).utcOffset() / 60,
          offsetText: result,
        };
      else return result;
    } else {
      return null;
    }
  }

  formatDuration(xDuration) {
    let result;
    switch (typeof xDuration) {
      case "string":
        if (
          (DURATION_STR.test(xDuration) &&
            !new RegExp(DURATION_ISO).test(xDuration)) ||
          MMYYYY.test(xDuration)
        ) {
          result = processDurationString(xDuration);
        } else {
          result = moment.duration(xDuration).asMilliseconds();
          if (!result)
            result = moment.duration(Number(xDuration)).asMilliseconds();
        }
        break;
      default:
        result = moment.duration(xDuration).asMilliseconds();
    }
  
    return result || result === 0 ? result : 'NaN';
  }
} // end methods

// PROCESS TIME STRING
const processTimeString = (xTime, tz) => {
  let result;

  result = parseAmTime(xTime, tz);
  if (!result) result = parseTime(xTime, tz);
  if (!result) result = getTime(xTime, tz);

  return result ? {
    time: result.time,
    tz: result.tz
  } : null;
};

const defineTime = (xTime, tz, formatsObj) => {
  let parsed, format;
  const regex = Object.keys(formatsObj).find((regex) => {
    return !_.isNull(xTime.match(new RegExp("^" + regex + "$", "i")));
  });
  
  if (regex) {
    let newTime;

    if (!formatsObj[regex].format) format = formatsObj[regex];
    else format = formatsObj[regex].format;

    if (/(mmZ)|(ssZ)|(ss\[Z\]Z)/.test(format)) {
      if (!tz) tz = {
        offset: ""
      };
      tz.offset = xTime.match(/Z?(\+|-)\d{2}:?\d{2}$/)[0];
      newTime = xTime.replace(tz.offset, "");
      tz.offset = getTimezoneOffset(tz.offset.replace('Z', '')).offset;
      format = format.replace(/(\[Z\])?Z/, '');
    } else if (/\[Z\]$/.test(format)) {
      if (!tz) tz = {
        offset: ""
      };
      tz.offset = "Z";
    }
    
    if (formatsObj[regex].sep) {
      if (newTime && /\.|-/.test(newTime)) {
        if (/-/.test(newTime)) newTime = newTime.replace(/-/g, ":");
        else newTime = newTime.replace(/\./g, ":");
      } else if (!newTime && /\.|-/.test(xTime) && !/\.\d\d\dZ/.test(xTime)) {
        if (/-/.test(xTime)) newTime = xTime.replace(/-/g, ":");
        else newTime = xTime.replace(/\./g, ":");
      }
    }
    if (newTime) xTime = xTime.replace(xTime, newTime);
    parsed = moment.utc(xTime, format);
    
    if (parsed.format() === "Invalid date" && !parsed.isValid()) {
      parsed = "Invalid date";
    } else if (parsed && tz) {
      parsed = parsed.format('HH:mm:ss.SSS'); 
      
      if (tz.offset) {
        parsed = parsed + tz.offset; // set timezone offset if it's defined in the input value
      } else if (tz.location) {
        parsed = parsed + moment().tz(tz.location).format("Z"); // set timezone if it's defined in the input value
      }
    } else {
      parsed = parsed.format(/Z/.test(format) ? 'HH:mm:ss.SSSZ' : 'HH:mm:ss.SSS');
    }
  }
  if (parsed && parsed !== 'Invalid date') return {
    time: parsed,
    tz
  };
  else return null;
}

const parseTime = (xTime, tz) => {
  return defineTime(xTime, tz, TIMES);
};

const parseAmTime = (xTime, tz) => {
  return defineTime(xTime, tz, AMPM_TIME);
};

const getTime = (xTime, tz) => {
  const hh_mm_ss_S = /(^(([1-9])|([0-1][0-9])|([2][0-4])):[0-5][0-9]:[0-5][0-9]\.\d+$)/;
  const HHMM = /^(([0-1]\d)|(2[0-3]))[0-5]\d$/;
  const DATE_ISO = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}((Z|(\.\d{3}Z))|((Z)?(\+|-)\d{2}:?\d{2})))?$/;
  const TIME_str = /^((\d+\s?(h(ours)?))(\s\d+\s?(m(inutes)?))?(\s\d+\s?(s(econds)?))?(\s\d+\s?(ms|milliseconds))?)$/ig;

  let time, result;
  if (xTime.match(DATE_ISO)) {
    time = xTime.match(DATE_ISO)[0].split("T")[1];
    let offset = time.match(/(Z|((\.\d{3}Z))|(Z?(\+|-)\d{2}:?\d{2}))$/);
    if (offset && (offset[0] === 'Z' || /(\.\d{3}Z)$/.test(offset[0]))) {
      tz = {offset: "+00:00"};
      if (/(\.\d{3}Z)$/.test(offset[0])) {
        time = time.replace(/(\.\d{3}Z)$/, 'Z');
      }
    }
    result = {
      time,
      tz
    };
  } else if (TIME_str.test(xTime)) {
    let hh, mm, ss;
    let match = xTime.match(TIME_STR);
    time = match.reduce((acc, item) => {
      let number = item.match(/\d+/);
      let prop = item.substring(number.index + number[0].length);
      acc[_.trim(prop, " ")] = number[0];
      return acc;
    }, {});
    hh = moment.duration(time).get("hours");
    mm = moment.duration(time).get("minutes");
    ss = moment.duration(time).get("seconds");

    if (hh.toString().length === 1) hh = '0' + hh.toString();
    if (mm.toString().length === 1) mm = '0' + mm.toString();
    if (ss.toString().length === 1) ss = '0' + ss.toString();
    result = {
      time: hh + ":" + mm + ":" + ss + ".000",
      tz
    }
  } else if (HHMM.test(xTime)) {
    result = {
      time: xTime.slice(0, 2) + ":" + xTime.slice(2) + ':00.000',
      tz
    };
  } else if (hh_mm_ss_S.test(xTime)) {
    result = {
      time: moment(xTime, 'HH:mm:ss.S').format("HH:mm:ss"),
      tz
    };
  } else if (!_.isNaN(Number(xTime))) {
    let hh, mm, ss;
    time = Number(xTime);
    hh = moment.duration(time).get("hours");
    mm = moment.duration(time).get("minutes");
    ss = moment.duration(time).get("seconds");

    if (hh.toString().length === 1) hh = '0' + hh.toString();
    if (mm.toString().length === 1) mm = '0' + mm.toString();
    if (ss.toString().length === 1) ss = '0' + ss.toString();
    result = {
      time: hh + ":" + mm + ":" + ss + ".000",
      tz
    }
  }
  return result;
};
// end PROCESS TIME STRING

// PROCESS DATE STRING
const processDateString = (inputDate, xYear, tz, weekDay) => {
  let time = "",
    type = '',
    format = "",
    additionalFormat = "",
    result = null;

  const DD_MM_YYYY = /^((\d\d?-\d\d?-(\d\d\d\d))|(\d\d?\.\d\d?\.(\d\d\d\d))|(\d\d?\/\d\d?\/(\d\d\d\d))|(\d\d?\s\d\d?\s(\d\d\d\d)))$/;
  const YYYY_MM_DD = /^(((\d\d\d\d)-\d\d?-\d\d?)|((\d\d\d\d)\.\d\d?\.\d\d?)|((\d\d\d\d)\s\d\d?\s\d\d?)|((\d\d\d\d)\/\d\d?\/\d\d?))$/;

  let trimmed = getZoneAndWeekday(inputDate, tz);
  if (trimmed.tz) tz = trimmed.tz;
  if (trimmed.weekDay) weekDay = trimmed.weekDay;
  if (trimmed.date) inputDate = trimmed.date;

  if (MMYYYY.test(inputDate)) {
    if (/\\s|\.|\//.test(inputDate)) {
      inputDate = inputDate.replace(/\\s|\.|\//g, "-");
    }

    let arr = inputDate.split("-");
    if (arr[0].length === 4) format = `YYYY-MM`;
    else format = `MM-YYYY`;

    result = moment.utc(inputDate, format);
    
    type = 'date';
  } else if (YY_MM_DD.test(inputDate)) { // 6-10-20 | 10-20-06
    let dayFormat = format;
    let sep, date;
    date = inputDate.match(YY_MM_DD)[0];

    let parts = /-/.test(date) ?
      date.split("-") :
      /\//.test(date) ?
      date.split("/") :
      /\./.test(date) ?
      date.split(".") :
      date.split(" ");
    sep = /-/.test(date) ?
      "-" : /\//.test(date) ?
      "/" : /\./.test(date) ?
      "." : " ";

    if (parts.length) {
      if (Number(parts[0]) <= 12 && parts[2].length === 2) {
        format = dayFormat + "MM" + sep + "DD" + sep + "YY";
        additionalFormat = dayFormat + "DD" + sep + "MM" + sep + "YY";
      } else {
        if (parts[2].length === 2) {
          format = dayFormat + "DD" + sep + "MM" + sep + "YY";
          additionalFormat = dayFormat + "YY" + sep + "MM" + sep + "DD";
        } else {
          format = dayFormat + "YY" + sep + "MM" + sep + "DD";
          additionalFormat = dayFormat + "YY" + sep + "DD" + sep + "MM";
        }
      }
    }
  
    result = moment.utc(weekDay + date + time.value, [
      format,
      additionalFormat, dayFormat + "YY" + sep + "DD" + sep + "MM"
    ]);
    
    type = 'date';
  } else if (DD_MM_YYYY.test(inputDate) || YYYY_MM_DD.test(inputDate)) { // 12-10-2020
    if (DD_MM_YYYY.test(inputDate)) {
      format = ['MM-DD-YYYY', 'DD-MM-YYYY'];
    } else { // YYYY_MM_DD
      format = ['YYYY-MM-DD', 'YYYY-DD-MM'];
    }
    result = moment.utc(inputDate, format)
     
    type = 'date';
  } else if (new RegExp('^' + DDMMYYYY).test(inputDate) || new RegExp(DDMMYYYY + '$').test(inputDate) ||
    new RegExp('^' + YYYYMMDD).test(inputDate) || new RegExp(YYYYMMDD + '$').test(inputDate)) {
    const amPmTime = /\d\s?((am|pm)\b)/i.test(inputDate);
    if (new RegExp('^' + DDMMYYYY).test(inputDate) || new RegExp(DDMMYYYY + '$').test(inputDate)) { // 6-10-2020 | 10-6-2020 + time

      if (new RegExp('^' + DDMMYYYY + '$').test(inputDate)) {
        result = {
          parsed: moment.utc(inputDate, ['MM-DD-YYYY', 'DD-MM-YYYY']).format("YYYY-MM-DD[T]HH:mm:ss.SSSZ")
        };
        
        type = 'date';
      } else if (amPmTime) {
        result = defineDate(
          MATCH_DATE.day_month_year_ampm,
          inputDate,
          tz,
          weekDay,
          xYear
        );
      } else {
        result = defineDate(
          MATCH_DATE.day_month_year_time,
          inputDate,
          tz,
          weekDay,
          xYear
        );
      }
    } else if (new RegExp('^' + YYYYMMDD).test(inputDate) || new RegExp(YYYYMMDD + '$').test(inputDate)) { // 2020-6-10 | 2020-10-06 + time

      if (new RegExp('^' + YYYYMMDD + '$').test(inputDate)) {
        result = {
          parsed: moment.utc(inputDate, ['YYYY-MM-DD', 'YYYY-DD-MM']).format("YYYY-MM-DD[T]HH:mm:ss.SSSZ")
        };
         
        type = 'date';
      } else if (amPmTime) {
        result = defineDate(
          MATCH_DATE.year_month_day_ampm,
          inputDate,
          tz,
          weekDay,
          xYear
        );
      } else {
        result = defineDate(
          MATCH_DATE.year_month_day_time,
          inputDate,
          tz,
          weekDay,
          xYear
        );
      }
    }
    if (result) tz = result.tz;

    return result ? {
      type: result.type,
      date: result.parsed,
      tz: tz && tz.offset ? tz.offset : tz && tz.location ? tz.location : ""
    } : null;

  } else if (new RegExp(test_short_date.YY_MM_DD).test(inputDate)) {
    result = defineShortDate(MATCH_SHORT_DATE_TIME.DATE_TIME, inputDate, tz);
    if (!result) result = defineShortDate(MATCH_SHORT_DATE_TIME.DATE_AMPM_TIME, inputDate, tz);

    if (result) tz = result.tz;

    return result ? {
      date: result.parsed,
      tz: tz && tz.offset ? tz.offset : tz && tz.location ? tz.location : ""
    } : null
  } else {
    const HHA = /^(\d\d?\s?((am|pm)\b))|(\d\d?:([0-5]\d)(:([0-5]\d))?\s?((am|pm)\b)?(,\s)?)$/i;
    const HH_MM_SSA = /^((([1][0-2]|[0]?\d):[0-5]\d(:[0-5]\d)?\s?((am|pm)\b)|([1][0-2]|[0]?\d)\s[0-5]\d(\s[0-5]\d)?\s?((am|pm)\b)|([1][0-2]|[0]?\d)\.[0-5]\d(\.[0-5]\d)?\s?((am|pm)\b)|([1][0-2]|[0]?\d)-[0-5]\d(-[0-5]\d)?\s?((am|pm)\b)|([1][0-2]|[0]?\d),[0-5]\d(,[0-5]\d)?\s?((am|pm)\b))|(([0-1]?\d|[2][0-4]):[0-5]\d(:[0-5]\d)?\s?|([0-1]?\d|[2][0-4])\s[0-5]\d(\s[0-5]\d)?\s?|([0-1]?\d|[2][0-4])\.[0-5]\d(\.[0-5]\d)?\s?|([0-1]?\d|[2][0-4])-[0-5]\d(-[0-5]\d)?\s?|([0-1]?\d|[2][0-4]),[0-5]\d(,[0-5]\d)?\s?))$/i;
    const time_Z = /^[0-2]\d:[0-5]\d:[0-5]\d(Z|(\.\d{3}Z)|((\+|-)\d{2}:?\d{2}))?$/;

    if (
      !HHA.test(inputDate) &&
      !HH_MM_SSA.test(inputDate) &&
      !time_Z.test(inputDate) &&
      inputDate
    ) {
      
      if (!_.isNaN(Number(inputDate)) && !/\./.test(inputDate)) {
        // ms duration as string
        result = moment.unix(Number(inputDate)).utc();
        if (
          result.isValid() &&
          (result.toISOString().split("-")[0].length > 4 ||
            !/(\b[1-2][0-9]{3}\b)/.test(result.year()))
        ) {
          result = moment.utc(Number(inputDate));
        }
      } else if (inputDate.match(new RegExp("^" + DURATION_ISO + "$"))) {
        let match;
        // ISO duration --> PT444037H35M28S
        match = inputDate.match(new RegExp("^" + DURATION_ISO + "$"))[0];
        if (match) result = moment.utc(moment.duration(match).asMilliseconds());
      }
    }
  }
  const yearValue = result ? /(\b\d\d\d\d\b)/.test(result.year()) : null;

  if (
    (result && result.format() === "Invalid date" && !result.isValid()) ||
    !yearValue
  ) {
    result = null;
  } else if (result && tz) {
    result = result.format("YYYY-MM-DD[T]HH:mm:ss.SSS");
    if (tz.offset) { 
      result = result + tz.offset; // set timezone offset if it's defined in the input value
    } else if (tz.location) {
      result = moment 
        .tz(result, tz.location)
        .format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"); // set timezone if it's defined in the input value
    }
  } else {
    result = result.format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
  }

  return result ? {
    type,
    date: result,
    tz: tz && tz.offset ? tz.offset : tz && tz.location ? tz.location : "",
  } : null;
};

const matchDateFormat = (input, xYear) => { 
  if (!new RegExp(months, "i").test(input)) return null;
  const strDay_Month = new RegExp("^" + stringDay + date_sep + months + "$", "i");
  const month_StrDay = new RegExp("^" + months + date_sep + stringDay + "$", "i");
  const dd_MMMM = new RegExp(
    "^" +
    "((([1-2][0-9])|(3[0-1])|(0?[1-9]))(th|rd|st|nd)?)" +
    date_sep +
    months +
    "$",
    "i"
  );
  const MMMM_dd = new RegExp(
    "^" +
    months +
    date_sep +
    "((([1-2][0-9])|(3[0-1])|(0?[1-9]))(th|rd|st|nd)?)" +
    "$",
    "i"
  );
  const month_DD_YY = new RegExp("^((" + months + "\\/\\d\\d?\\/\\d\\d)|(" + months + "\\.\\d\\d?\\.\\d\\d)|(" + months + "\\s\\d\\d?\\s\\d\\d)|(" + months + "-\\d\\d?-\\d\\d))$", 'i')
  const YY_DD_month = new RegExp("^((\\d\\d\\/\\d\\d?\\/" + months + ")|(\\d\\d\\.\\d\\d?\\." + months + ")|(\\d\\d\\s\\d\\d?\\s" + months + ")|(\\d\\d-\\d\\d?-" + months + "))$", 'i');
  const YY_month_DD = new RegExp("^((\\d\\d?\\/" + months + "\\/\\d\\d?)|(\\d\\d?\\." + months + "\\.\\d\\d?)|(\\d\\d?\\s" + months + "\\s\\d\\d?)|(\\d\\d?-" + months + "-\\d\\d?))$", 'i');

  let result,
    type = '',
    dayNum,
    dayStr,
    month,
    tz,
    weekDay = "";

  let trimmed = getZoneAndWeekday(input, tz);
  if (trimmed.tz) tz = trimmed.tz;
  if (trimmed.weekDay) weekDay = trimmed.weekDay;
  if (trimmed.date) input = trimmed.date;

  if (
    month_DD_YY.test(input) ||
    YY_DD_month.test(input) ||
    YY_month_DD.test(input)
  ) {
    // Apr/20/10
    type = "date";
    input = input.replace(/\s|\.|\//g, "-");
    if (month_DD_YY.test(input))
      result = moment
        .utc(input, "MMMM-DD-YY")
        .format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
    // 'MMMM-DD-YY'
    else if (YY_DD_month.test(input))
      result = moment
        .utc(input, "YY-DD-MMMM")
        .format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
    // 'YY-DD-MMMM'
    else
      result = moment(input.replace(/\s|\.|\//g, "-"), [
        "YY-MMMM-DD",
        "DD-MMMM-YY",
      ]).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"); // 'YY-MMMM-DD', 'DD-MMMM-YY'
  } else if (
    dd_MMMM.test(input) ||
    MMMM_dd.test(input) ||
    month_StrDay.test(input) ||
    strDay_Month.test(input)
  ) {
    // only day + month
    month = input.match(new RegExp(months, "i"))[0];
    type = "date";
    if (dd_MMMM.test(input) || MMMM_dd.test(input)) {
      dayNum = parseInt(
        input.match(/((([1-2][0-9])|(3[0-1])|([1-9]))(th|rd|st|nd)?)/i)[0]
      );
    } else if (month_StrDay.test(input) || strDay_Month.test(input)) {
      dayStr = input.match(new RegExp(stringDay, "i"))[0];
      dayNum = getDayNum(dayStr);
    }
    if (dayNum && month) {
      result = moment
        .utc(`${dayNum}-${month}-${xYear}`)
        .format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
      if (result === "Invalid date") {
        result = null;
      }
    }
  } else if (
    new RegExp(test_short_date.month_DD_YY, "i").test(input) ||
    new RegExp(test_short_date.YY_DD_month, "i").test(input) ||
    new RegExp(test_short_date.YY_month_DD, "i").test(input)
  ) {
    result = defineShortDate(
      MATCH_SHORT_DATE_TIME.STR_MONTH_DATE_TIME,
      input,
      tz
    );
    if (!result)
      result = defineShortDate(
        MATCH_SHORT_DATE_TIME.STR_MONTH_DATE_AMPM_TIME,
        input,
        tz
      );

    if (result) {
      if (!tz) tz = result.tz;
      result = result.parsed;
    }
    
  } else {
    const strDayDate = new RegExp(stringDay, "i").test(input);
    const amPmTime = /\d\s?((am|pm)\b)/i.test(input);
    const ordinalDayDate = new RegExp(ordinalDay, "i").test(input);

    if (strDayDate) {
      // string day and time
      if (amPmTime) {
        result = defineDate(
          MATCH_DATE.stringDay_date_ampm,
          input,
          tz,
          weekDay,
          xYear
        );

        if (!result || !result.parsed)
          result = defineDate(
            MATCH_DATE.stringDay_year_ampm,
            input,
            tz,
            weekDay,
            xYear
          );
      } else {
        result = defineDate(
          MATCH_DATE.stringDay_time,
          input,
          tz,
          weekDay,
          xYear
        );
        if (!result || !result.parsed)
          result = defineDate(
            MATCH_DATE.stringDay_year_date,
            input,
            tz,
            weekDay,
            xYear
          );
      }

      if (!result || !result.parsed)
        result = defineDate(
          MATCH_DATE.stringDay_year_time,
          input,
          tz,
          weekDay,
          xYear
        );
    } else if (ordinalDayDate) {
      // ordinal day and time
      if (amPmTime) {
        result = defineDate(
          MATCH_DATE.ordinalDay_date_ampm,
          input,
          tz,
          weekDay,
          xYear
        );
        if (!result || !result.parsed)
          result = defineDate(
            MATCH_DATE.ordinalDay_year_ampm,
            input,
            tz,
            weekDay,
            xYear
          );
      } else {
        result = defineDate(
          MATCH_DATE.ordinalDay_time,
          input,
          tz,
          weekDay,
          xYear
        );

        if (!result || !result.parsed)
          result = defineDate(
            MATCH_DATE.ordinalDay_year_date,
            input,
            tz,
            weekDay,
            xYear
          );
      }

      if (!result || !result.parsed)
        result = defineDate(
          MATCH_DATE.ordinalDay_year_time,
          input,
          tz,
          weekDay,
          xYear
        );
    } else {
      // simple
      if (amPmTime) {
        result = defineDate(
          MATCH_DATE.simple_date_ampm,
          input,
          tz,
          weekDay,
          xYear
        );
        if (!result)
          result = defineDate(
            MATCH_DATE.simple_date_year_ampm,
            input,
            tz,
            weekDay,
            xYear
          );
      } else {
        result = defineDate(
          MATCH_DATE.simple_date_time,
          input,
          tz,
          weekDay,
          xYear
        );
        if (!result) {
          result = defineDate(
            MATCH_DATE.simple_date_year,
            input,
            tz,
            weekDay,
            xYear
          );
        }
      }

      if (!result || !result.parsed)
        result = defineDate(
          MATCH_DATE.simple_date_year_time,
          input,
          tz,
          weekDay,
          xYear
        );
    }
    if (result) {
      if (!tz) tz = result.tz;
      if (result.type) type = result.type;
      result = result.parsed;
    }
  }
 
  return result ? {
    type,
    date: result,
    tz: tz && tz.offset ? tz.offset : tz && tz.location ? tz.location : "",
  } : null;
};

const getZoneAndWeekday = (input, tz) => {
  let weekDay;
  if (TIMEZONES.test(input) && !UTC_OFFSET.test(input)) {
    const matchZone = input.match(TIMEZONES);
    tz = {
      location: matchZone[0],
    };
    if (matchZone.index)
      input =
      input.slice(0, matchZone.index) +
      input.slice(tz.location.length + matchZone.index);
    else input = input.slice(tz.location.length);
  } else if (!tz && input.match(UTC_OFFSET)) {
    let utc = input.match(UTC_OFFSET);
    let sep = /\+/.test(utc[0]) ? "+" : "-";
    let offset = utc[0].match(new RegExp(HH_OFFSET_RANGE))[0];
    offset = offset.match(/((1[0-2])|(0?\d))|(\+1[3,4])/)[0];
    offset = offset.length === 1 ? "0" + offset : offset;
    tz = {
      offset: sep + offset + ":00"
    };
    input = input.replace(utc[0], '');
    input = trimString(input);
  }

  if (DAY_OF_WEEK.test(input)) {
    const matchWeekDay = input.match(DAY_OF_WEEK);
    weekDay = matchWeekDay[0].trim();
    if (matchWeekDay.index)
      input =
      input.slice(0, matchWeekDay.index) +
      input.slice(weekDay.length + matchWeekDay.index);
    else input = input.slice(weekDay.length);
  }

  return {
    weekDay,
    date: trimString(input),
    tz
  };
}

const getDayNum = (dayStr) => {
  let dayNum;
  if (["thirtieth", "thirty"].indexOf(dayStr) !== -1) {
    dayNum = 30;
  } else if (
    ["thirty first", "thirty one", "thirty-first", "thirty-one"].indexOf(
      dayStr
    ) !== -1
  ) {
    dayNum = 31;
  } else {
    Object.keys(dg).forEach((key, i) => {
      if (i && (key === dayStr || dg[key] === dayStr)) {
        dayNum = i;
      }
    });
  }

  if (!dayNum) {
    let arr;
    if (/-/.test(dayStr)) arr = dayStr.split("-");
    else arr = dayStr.split(" ");
    if (arr[0] === "twenty") {
      dayNum = 20;
      Object.keys(dg).forEach((key, i) => {
        if (i && (key === arr[1] || dg[key] === arr[1])) {
          dayNum = dayNum + i;
        }
      });
    }
  }
  return dayNum;
};

const defineShortDate = (formatsObj, input, tz) => {
  let parsed, format, additionalFormat, weekDay; 

  let trimmed = getZoneAndWeekday(input);
  if (trimmed.tz) tz = trimmed.tz;
  if (trimmed.weekDay) weekDay = trimmed.weekDay;
  if (trimmed.date) input = trimmed.date;

  const regex = Object.keys(formatsObj).find((regex) => {
    return !_.isNull(input.match(new RegExp("^(" + regex + ")$", "i")));
  });
 
  if (regex) {
    format = formatsObj[regex].format;
    if (formatsObj[regex].additionalFormats) additionalFormat = formatsObj[regex].additionalFormats;

    let date;
    if (formatsObj[regex].date) {
      if (/((YY)|(DD)|(MMMM)|(MM))$/.test(format)) {
        date = input.match(new RegExp(formatsObj[regex].date + "$", 'i'))[0];
      } else if (/^((YY)|(DD)|(MMMM)|(MM))/.test(format)) {
        date = input.match(new RegExp("^" + formatsObj[regex].date, 'i'))[0];
      }
    } else {
      date = input.match(new RegExp(regex, 'i'))[0];
    }
  
    if (/\\s|\.|\//.test(date)) {
      let newDate = date.replace(/\\s|\.|\//g, "-");
      input = input.replace(date, newDate);
    }

    if (weekDay) {
      if (weekDay.length === 3) {
        format = format + " ddd";
        if (additionalFormat) additionalFormat = additionalFormat.map(f => f + " ddd");
      } else {
        format = format + " dddd";
        if (additionalFormat) additionalFormat = additionalFormat.map(f => f + " dddd");
      }
      input = input + " " + weekDay;
    }
    if (additionalFormat) format = [format].concat(additionalFormat);
    parsed = moment.utc(input, format);
    if (parsed.format() === "Invalid date" && !parsed.isValid()) {
      parsed = "Invalid date";
    } else if (parsed && tz) {
      parsed = parsed.format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");

      if (tz.offset) {
        parsed = setTimezone(parsed, '', tz.offset) // set timezone offset if it's defined in the input value
      } else if (tz.location) {
        parsed = setTimezone(parsed, '', tz.location) // set timezone if it's defined in the input value
      }
    } else {
      parsed = parsed.format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
    }
  }
  return parsed && parsed !== 'Invalid date' ? {
    parsed,
    tz
  } : null;
}

const defineDate = (formatsObj, input, tz, weekDay, xYear) => {
  let parsed, format, additionalFormat, dayStr, dayNum, type = '';

  const regex = Object.keys(formatsObj).find((regex) => {
    return !_.isNull(input.match(new RegExp("^" + regex + "$", "i")));
  });

  if (regex) {
    let time, newTime, date;

    if (!formatsObj[regex].format) format = formatsObj[regex];
    else format = formatsObj[regex].format;

    if (/MM-DD-YYYY/.test(formatsObj[regex].format)) additionalFormat = format.replace("MM-DD-YYYY", "DD-MM-YYYY");
    if (/YYYY-MM-DD/.test(formatsObj[regex].format)) additionalFormat = format.replace("YYYY-MM-DD", "YYYY-DD-MM");

    if (formatsObj[regex].date) {
      if (/((YYYY)|(DD)|(Do)|(MMMM)|(MM))$/.test(format)) {
        date = input.match(new RegExp(formatsObj[regex].date + "$", 'i'))[0];
      } else if (/^((YYYY)|(DD)|(Do)|(MMMM)|(MM))/.test(format)) {
        date = input.match(new RegExp("^" + formatsObj[regex].date, 'i'))[0];
      }
    } else {
      date = input.match(new RegExp(regex, 'i'))[0];
    }

    if (/\s|\.|\//.test(date)) {
      let newDate = date.replace(/\s|\.|\//g, "-");
      input = input.replace(date, newDate);
    }
    if (formatsObj[regex].time) {
      if (/^(D(D|o)-MM(MM)?-YYYY)/.test(formatsObj[regex].format) || /^(YYYY-MM(MM)?-D(D|o))/.test(formatsObj[regex].format) || /^(MM(MM)?-D(D|o)-YYYY)/.test(formatsObj[regex].format) || /^(YYYY-D(D|o)-MM(MM)?)/.test(formatsObj[regex].format) ||
        /^(D(D|o)-MMMM)/.test(formatsObj[regex].format) || /^(MMMM-D(D|o))/.test(formatsObj[regex].format)) {
        time = input.match(new RegExp(formatsObj[regex].time + '$', 'i'))[0];
      } else {
        time = input.match(new RegExp('^' + formatsObj[regex].time, 'i'))[0];
      }
 
      if (/(mmZ)|(ssZ)|(ss\[Z\]Z)/.test(format)) {
        if (!tz) tz = {
          offset: ""
        };
        tz.offset = time.match(/Z?(\+|-)\d{2}:?\d{2}$/)[0];

        newTime = time.replace(tz.offset, "");
        tz.offset = getTimezoneOffset(tz.offset.replace('Z', '')).offset;
        format = format.replace(/(\[Z\])?Z/, '');
        if (additionalFormat) additionalFormat = additionalFormat.replace(/(\[Z\])?Z/, '');
      } else if (/(\[Z\])/.test(format)) {
        if (!tz) tz = {
          offset: "+00:00"
        } 
        else tz.offset = "+00:00";
      }
      if (formatsObj[regex].timeSep && !/(\.SSS\[Z\])$/.test(formatsObj[regex].format)) {
        if (newTime && /\.|-/.test(newTime)) newTime = newTime.replace(/\.|-/g, ":");
        else if (!newTime && /\.|-/.test(time)) newTime = time.replace(/\.|-/g, ":");
      }
      if (newTime) input = input.replace(time, newTime);
    } else {
      type = 'date';
    }

    if (formatsObj[regex].stringDay) {
      dayStr = input.match(new RegExp(stringDay, "i"))[0];
      dayNum = getDayNum(dayStr);
      input = input.replace(dayStr, dayNum);
    }

    if (weekDay) {
      if (weekDay.length === 3) {
        format = format + " ddd";
        if (additionalFormat) additionalFormat = additionalFormat + " ddd";
      } else {
        format = format + " dddd";
        if (additionalFormat) additionalFormat = additionalFormat + " dddd";
      }
      input = input + " " + weekDay;
    }
    
    if (/YYYY/.test(format)) {
      if (additionalFormat) parsed = moment.utc(input, [format, additionalFormat]);
      else parsed = moment.utc(input, format);
    } else {
      parsed = moment.utc(input, format).set("year", xYear);
    }
   
    if (parsed.format() === "Invalid date" && !parsed.isValid()) {
      parsed = "Invalid date";
    } else if (parsed && tz) {
      parsed = parsed.format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");
      if (tz.offset) {
        parsed = parsed.slice(0, -6) + tz.offset; // set timezone offset if it's defined in the input value
      } else if (tz.location) {
        parsed = moment
          .tz(parsed.slice(0, -6), tz.location)
          .format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"); // set timezone if it's defined in the input value
      }
    } else {
      parsed = parsed.format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
    }
  }
  
  return parsed && parsed !== 'Invalid date' ? {
    type,
    parsed,
    tz
  } : null;
};
// end PROCESS DATE STRING

// secondary functions
const trimString = input => {
  input = input.replace(/,/g, " ").trim();
  input = input.replace(/\s\s(\s)?/g, " ");
  input = input.trim();
  return input;
}

const processDurationString = (value) => {
  let result;
  if (value.match(DURATION_STR)) {
    let match = _.uniq(value.match(DURATION_STR));
    let number, prop;
    let validStr = '';
    match = match.reduce((acc, item) => {
      number = item.match(/\d+/);
      prop = item.substring(number.index + number[0].length);
      prop = _.trim(prop, " ");

      validStr = validStr + number + prop;

      if (prop === 'sec') prop = 'seconds';
      else if (prop === 'min') prop = 'minutes';
      acc[prop] = number[0];
      return acc;
    }, {});
    
    if (validStr !== value.replace(/\s/g, "")) result = null;
    else result = moment.duration(match).asMilliseconds();
  } else if (MMYYYY.test(value)) {
    // 10-2020 | 2020/10 | 10 2020
    let sep = /\//.test(value) ?
      "/" :
      /-/.test(value) ?
      "-" :
      /\./.test(value) ?
      "." :
      " ";
    if (value.split(sep)[0].length === 4)
      value = value.split(sep)[0] + "-" + value.split(sep)[1];
    else value = value.split(sep)[1] + "-" + value.split(sep)[0];

    let days = moment.utc(value, "YYYY-MM").daysInMonth();
    result = moment.duration(days, "days").asMilliseconds();
  }

  return result;
};

const getTimezoneOffset = (value) => {
  let match, hh, offset, location;
  const sep = /\+/.test(value) ? "+" : "-";
  if (UTC_OFFSET.test(value)) {
    match = value.match(UTC_OFFSET)[0];
    match = match.match(new RegExp(HH_OFFSET_RANGE))[0];
    match = match.match(/((1[0-2])|(0?\d))|(\+1[3,4])/)[0];
    match = match.length === 1 ? "0" + match : match;
    offset = sep + match + ":00";
  } else if (TIMEZONES.test(value)) {
    // handle timezones as string (timezone name)
    location = value.match(TIMEZONES)[0];
  } else if (TZ_OFFSET.test(value)) {
    match = value.match(TZ_OFFSET)[0];
    if (/:/.test(match)) {
      match = match.split(":");
      hh = match[0].match(/\d\d?/)[0];
      hh = hh.length === 1 ? "0" + hh : hh;
      offset = sep + hh + ":" + match[1];
    } else {
      offset = match.slice(0, 3) + ":" + match.slice(3);
    }
  }
  return {
    offset,
    location,
  };
};

const setTimezone = (date, hasTZ, xTZ, yTZ) => {
  
  if (!hasTZ && xTZ) {
    // set the timezone that the user specified as default
    if (typeof date === "object") {
      date = date.toISOString().slice(0, -5);
    } else {
      if (/\.\d\d\dZ|Z/.test(date)) {
        date = date.replace("Z", "");
      } else {
        date = date.slice(0, -6);
      }
    }
    
    if (tzList.indexOf(xTZ) !== -1) {
      date = moment.tz(date, xTZ).format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    } else {
      if (!TZ_OFFSET.test(xTZ)) return null; // check if the value is a valid time offset
 
      date = date + xTZ;
    }
  }

  if (yTZ) {
    // adjust to the timezone if the user specified one (output timezone)
    if (typeof date === "object") {
      date = date.toISOString().slice(0, -6);
    }
    if (tzList.indexOf(yTZ) !== -1) {
      date = moment.utc(date).tz(yTZ).format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    } else {
      if (!TZ_OFFSET.test(yTZ)) return null; // check if the value is a valid time offset
      date = moment.utc(date).utcOffset(yTZ).format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
  }
  return date;
};
// end

module.exports = timeInterpreter;
